module.exports = __webpack_public_path__ + "img/memberInstagram.cc2f6b27.png";